export default __webpack_public_path__ + "static/media/f_label.788f2a4c.svg";